import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";

const TableData = ({ showIndex, columns, data, paginator, startRow, onSort, rowClick, rowSelector, checkbox, onChecked, checked, checkAll, disabledCheckbox }) => {
  const darkMode = useSelector(state => state.theme.darkMode);

  const [rowSelect, setRowSelect] = useState(0);
  const selector = rowSelector ? rowSelector : 'id';

  const onRowClick = (item) => {
    onChecked([]);
    setRowSelect(item[selector]);
    rowClick(item);
  }

  const onSingleCheck = (value) => {
    if (checkbox && checked && onChecked && checkAll) {
      const index = checked.findIndex(e => e == value);
      if (index > -1) {
        checked.splice(index, 1);
      } else {
        checked.push(value);
      }
      onChecked(checked);
      setRowSelect(0);
    } else if (checkbox && checked && onChecked) {
      checked.length > 0 ? onChecked([]) : onChecked([value]);
      setRowSelect(0);
    }
  }

  const onCheckAll = (e) => {
    if (checkbox && checked && onChecked && checkAll) {
      if (e.target.checked) {
        const _checked = [];
        data.map((item, i) => {
          if (!disabledCheckbox || !item[disabledCheckbox]) {
            _checked.push(item[checkbox]);
          }
        });
        onChecked(_checked);
        setRowSelect(0);
      } else {
        onChecked([]);
        setRowSelect(0);
      }
    }
  }

  useEffect(() => {
    onChecked && onChecked([]);
  }, [data]);

  return (
    <div className="row tbl-container">
      <div className="col-lg-12 col-md-12 col-12 tbl-fixed scroll">
        <table className={`table ${darkMode ? 'm-table-dark' : 'm-table'} table-condensed`} style={{ marginTop: 16 }}>
          <thead>
            <tr>
              {showIndex && (<th style={{ width: 60 }}>No</th>)}
              {checkbox &&
                (<th style={{ width: 60 }}>
                  {
                    checkAll
                      ? <input type="checkbox" checked={checked.length > 0} disabled={!checkAll} onChange={onCheckAll} />
                      : <input type="checkbox" disabled={!checkAll} />
                  }
                </th>)
              }
              {columns.map((item, i) => {
                return item.sortable
                  ? <th key={'key-' + i} style={item.style || {}}>
                    <div
                      className="d-flex"
                      style={{
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={onSort(item.field)} >
                      <span className="d-block mr-2 flex-1">{item.title}</span>
                      {paginator.orders.split(":")[0] == item.field &&
                        <i
                          className={
                            paginator.direction == 'asc'
                              ? 'fa fa-arrow-down'
                              : 'fa fa-arrow-up'
                          }
                        />}
                    </div>
                  </th>
                  : <th key={'key-' + i} style={item.style || {}}>{item.title}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 && data.map((item, i) => {
              const newStyle = rowClick ? { cursor: "pointer" } : {};
              const selectStyle = rowSelect == item[selector] || checked?.findIndex(e => e == item[checkbox]) > -1 ? { backgroundColor: darkMode ? '#6e5f28' : '#ffe99b' } : {};
              if (rowClick) {
                return (
                  <tr key={'key-' + i} style={{ ...selectStyle, ...newStyle }}>
                    {showIndex && (<td>{i + startRow}</td>)}
                    {checkbox && (<td>
                      <input type="checkbox" disabled={disabledCheckbox && item[disabledCheckbox]} checked={checked?.findIndex(e => e == item[checkbox]) > -1} onChange={(e) => onSingleCheck(item[checkbox])} />
                    </td>)}
                    {columns.map((col, j) => {
                      if (col.clickable) {
                        return (
                          <td key={'key_col' + j} style={col.style ? { ...col.style } : {}} onClick={() => onRowClick(item)}>
                            {col.render ? col.render(item) : item[col.field]}
                          </td>
                        );
                      } else {
                        return (
                          <td key={'key_col' + j} style={col.style ? { ...col.style } : {}}>
                            {col.render ? col.render(item) : item[col.field]}
                          </td>
                        );
                      }
                    })}
                  </tr>
                )
              } else {
                return (
                  <tr key={'key-' + i} style={{ ...selectStyle }}>
                    {showIndex && (<td>{i + startRow}</td>)}
                    {columns.map((col, j) => {
                      return (
                        <td key={'key_col' + j} style={col.style ? { ...col.style } : {}} >
                          {col.render ? col.render(item) : item[col.field]}
                        </td>
                      );
                    })}
                  </tr>
                )
              }
            })}
          </tbody>
        </table>
      </div>
    </div >
  )
}

export default TableData;